import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FC } from 'react';

import Segment from '../../interfaces/Segment';
import { useTranslations } from 'use-intl';

interface DeleteSegmentDialogProps {
  segment: Segment;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteSegmentDialog: FC<DeleteSegmentDialogProps> = ({
  segment,
  onDelete,
  onClose,
}) => {
  const t = useTranslations('rfmConfig');
  return (
    <Dialog open onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>{t('deleteDialog.title', { name: segment.name })}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {t.rich('deleteDialog.confirm', {
            name: segment.name,
            strong: (chunks) => <strong>{chunks}</strong>,
          })}
          <Alert severity='error' sx={{ mt: 2 }}>
            {t('deleteDialog.cannotUndo')}
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='secondary' onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button color='error' onClick={onDelete} autoFocus>
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteSegmentDialog;
